export const JOB_TYPE_LOAD_REQUEST = "JOB_TYPE_LOAD_REQUEST";
export const JOB_TYPE_LOAD_SUCCESS = "JOB_TYPE_LOAD_SUCCESS";
export const JOB_TYPE_LOAD_FAIL = "JOB_TYPE_LOAD_FAIL";
export const JOB_TYPE_LOAD_RESET = "JOB_TYPE_LOAD_RESET";

export const CREATE_JOB_TYPE_REQUEST = "CREATE_JOB_TYPE_REQUEST";
export const CREATE_JOB_TYPE_SUCCESS = "CREATE_JOB_TYPE_SUCCESS";
export const CREATE_JOB_TYPE_FAIL = "CREATE_JOB_TYPE_FAIL";
export const CREATE_JOB_TYPE_RESET = "CREATE_JOB_TYPE_RESET";